import { render, staticRenderFns } from "./actuals_start_events_report_tbn.vue?vue&type=template&id=a23eaf6a&scoped=true&"
import script from "./actuals_start_events_report_tbn.vue?vue&type=script&lang=js&"
export * from "./actuals_start_events_report_tbn.vue?vue&type=script&lang=js&"
import style0 from "./actuals_start_events_report_tbn.vue?vue&type=style&index=0&id=a23eaf6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23eaf6a",
  null
  
)

export default component.exports